'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/9/17.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _authManager = require('redux/modules/authManager');

var authActions = _interopRequireWildcard(_authManager);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalAuthManager = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch(authActions.getAuthInfo());
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.authManager.data,
    authModalOpened: state.authManager.authModalOpened,
    authOperating: state.authManager.authOperating
  };
}, authActions), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalAuthManager, _Component);

  function PersonalAuthManager() {
    (0, _classCallCheck3.default)(this, PersonalAuthManager);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalAuthManager).apply(this, arguments));
  }

  (0, _createClass3.default)(PersonalAuthManager, [{
    key: 'onAuthInfoClose',
    value: function onAuthInfoClose() {
      var closeAuthModal = this.props.closeAuthModal;

      if (closeAuthModal) {
        closeAuthModal();
      }
    }
  }, {
    key: 'onAuthSubmit',
    value: function onAuthSubmit(submitData) {
      var _props = this.props;
      var data = _props.data;
      var authOperate = _props.authOperate;
      var closeAuthModal = _props.closeAuthModal;

      var authData = {};
      if (data.authData) {
        authData = (0, _extends3.default)({}, data.authData, submitData, {
          组件编号: ''
        });
      }
      if (authOperate) {
        if (authData.id && authData.id !== '') {
          authData.effectiveTag = '3';
        } else {
          authData.effectiveTag = '2';
        }
        //  data.orderNumber
        authOperate(authData).then(function (resultData) {
          if (resultData && (resultData.operateResultError === null || typeof resultData.operateResultError === 'undefined')) {
            closeAuthModal();
          }
        });
      }
    }
  }, {
    key: 'onRemoveItem',
    value: function onRemoveItem(info) {
      var infoData = (0, _extends3.default)({}, info);
      var authOperate = this.props.authOperate;

      if (authOperate) {
        infoData.effectiveTag = '-1';
        authOperate(infoData);
      }
    }
  }, {
    key: 'onEditItem',
    value: function onEditItem(info) {
      var editAuthInfo = this.props.editAuthInfo;

      if (editAuthInfo) {
        editAuthInfo(info);
      }
    }
  }, {
    key: 'onAuthInfo',
    value: function onAuthInfo() {
      var authInfo = this.props.authInfo;

      if (authInfo) {
        authInfo();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./PersonalAuthManager.scss');
      var _props2 = this.props;
      var data = _props2.data;
      var authModalOpened = _props2.authModalOpened;
      var authOperating = _props2.authOperating;

      var content = '';
      if (data && data.auth instanceof Array) {
        content = data.auth.map(function (singleAtuhInfo, index) {
          return _react2.default.createElement(_components.SingleAuthInfo, { key: index, info: singleAtuhInfo, onRemoveItem: _this2.onRemoveItem.bind(_this2),
            onEditItem: _this2.onEditItem.bind(_this2),
            index: index });
        });
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: styles.table },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { width: '8%' }),
            _react2.default.createElement('col', { width: '37%' }),
            _react2.default.createElement('col', { width: '37%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '8%' })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                ' '
              ),
              _react2.default.createElement(
                'th',
                null,
                '授权人'
              ),
              _react2.default.createElement(
                'th',
                null,
                '手机'
              ),
              _react2.default.createElement(
                'th',
                null,
                '是否默认'
              ),
              _react2.default.createElement(
                'th',
                null,
                ' '
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            content
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.SubmitBtn, { text: '新增授权人', btnClick: this.onAuthInfo.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        data && data.authData ? _react2.default.createElement(_components.AuthInfoModal, { isOpened: authModalOpened, initialValues: data.authData,
          operating: authOperating,
          errMessage: data.operateResultError,
          onSubmit: this.onAuthSubmit.bind(this),
          onClose: this.onAuthInfoClose.bind(this) }) : ''
      );
    }
  }]);
  return PersonalAuthManager;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object,
  closeAuthModal: _react.PropTypes.func,
  authOperate: _react.PropTypes.func,
  authInfo: _react.PropTypes.func,
  editAuthInfo: _react.PropTypes.func,
  authModalOpened: _react.PropTypes.bool,
  authOperating: _react.PropTypes.bool
}, _temp)) || _class) || _class);
exports.default = PersonalAuthManager;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalAuthManager/PersonalAuthManager.js
 ** module id = 1513
 ** module chunks = 0
 **/